import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { calculatePercentage } from "../../sysGuardConstants";
import { GOOGLEWORKSPACE } from "../../../../redux/constants/constants";
import { isNull } from "lodash";
import { useSysGuardDataSource } from "../../SysGuardCommonComp";

const RadialProgress = ({ loc, data }) => {
  const sysGuardData = useSysGuardDataSource();
  const dataSourceType =  sysGuardData?.type?.code;
  const isGoogleWorkspace = dataSourceType === GOOGLEWORKSPACE;
  const location = data?.location;
  const device = data?.device;
  const mfa = data?.mfa;
  const suspicious = data?.suspicious;
  const userWithMoreThanTwoDevices = data?.userWithMoreThanTwoDevices;
  const getDeviceData = () => {
    if (isGoogleWorkspace) {
      return {
        percentage: calculatePercentage(
          userWithMoreThanTwoDevices?.totalCount,
          suspicious?.totalCount
        ),
        value: device?.totalCount || 0,
        maxValue: null,
        title: "Total Devices",
        img: "/sysGuardIcons/fingerPrint.svg",
        colorImg: "/sysGuardIcons/colorFingerprint.svg",
        alt: "finger Icon",
        progressColor: "#dd5434",
      };
    } else {
      return {
        percentage: calculatePercentage(device?.alertCount, device?.totalCount),
        value: device?.alertCount || 0,
        maxValue: device?.totalCount || 0,
        title: "Device Based Risk",
        img: "/sysGuardIcons/fingerPrint.svg",
        colorImg: "/sysGuardIcons/colorFingerprint.svg",
        alt: "finger Icon",
        progressColor: "#dd5434",
      };
    }
  };
  const radialData = [
    {
      percentage: calculatePercentage(
        location?.alertCount,
        location?.totalCount
      ),
      value: location?.alertCount || 0,
      maxValue: location?.totalCount || 0,
      title: "Location Anomalies",
      img: "/sysGuardIcons/locationIcon.svg",
      colorImg: "/sysGuardIcons/colorLocation.svg",
      alt: "location Icon",
      progressColor: "#a6ce39",
    },
    getDeviceData(),
    {
      percentage: calculatePercentage(mfa?.totalCount - mfa?.enabledCount, mfa?.totalCount),
      value:  mfa?.totalCount - mfa?.enabledCount || 0,
      maxValue: mfa?.totalCount || 0,
      title: "Accounts W/O MFA",
      img: "/sysGuardIcons/shield.svg",
      colorImg: "/sysGuardIcons/colorShield.svg",
      alt: "shield Icon",
      progressColor: "#e9b047",
    },
    {
      percentage: calculatePercentage(
        suspicious?.alertCount,
        suspicious?.totalCount
      ),
      value: suspicious?.alertCount || 0,
      maxValue: suspicious?.totalCount || 0,
      title: "Suspicious User Behavior",
      img: "/sysGuardIcons/danger.svg",
      colorImg: "/sysGuardIcons/colorDanger.svg",
      alt: "danger Icon",
      progressColor: "#e33d47",
    },
  ];

  const renderProgressColor = (value) => {
    if (value === 0) {
      return "#8dc63f";
    } else if (value <= 50) {
      return "#e9b047";
    } else {
      return "#f43860";
    }
  };

  const renderClassNames = () => {
    if (loc === "Content") {
      return "sys-guard-radial-progress-bar-container sys-guard-content";
    } else {
      return "sys-guard-radial-progress-bar-container";
    }
  };

  return (
    <div className={renderClassNames()}>
      {radialData.map((e, index) => (
        <div key={index} className="sys-guard-text-container">
          <img src={e.img} alt={e.alt} />
          <div className="sys-guard-radial-text">{e.title}</div>
          <div className="sys-guard-radial-progress">
            <CircularProgressbarWithChildren
              value={e.percentage}
              styles={buildStyles({
                pathColor: renderProgressColor(e.percentage),
                strokeLinecap: "butt",
                trailColor: "#9cca3f",
              })}
              strokeWidth={10}
            >
              <div className="circular-progress-bar-text">
                <div className="text-sm" title={isGoogleWorkspace && isNull(e.maxValue)
                      ? `Total number of devices: ${e.value}`
                      : ""}>
                  {isNull(e.maxValue) ? e.value : `${e.value}/${e.maxValue}`}
                </div>
                <div
                  className={loc === "Content" ? "content" : "text-l"}
                  title={
                    isGoogleWorkspace && isNull(e.maxValue)
                      ? `${e.percentage}% of users have more than two devices`
                      : ""
                  }
                >{`${e.percentage}%`}</div>
              </div>
            </CircularProgressbarWithChildren>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RadialProgress;
